import { Component, HostListener, Input, OnInit, OnChanges, QueryList, ViewChildren } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import _, { random } from 'lodash';
import { RootScopeService } from 'src/app/services/root-scope.service';
import { WrapUpData } from '../../../models/WrapUpData';
import * as Constants from '../../../models/Constants';
import { ApiService } from 'src/app/services/api.service';
import { MatTableDataSource } from '@angular/material/table';
import { GenesysCloudService } from '../../../services/genesys-cloud.service';
import { MatSelect } from '@angular/material/select';
import { CustBusService } from 'src/app/services/customer-search-bussiness-logic.service';
import { InteractionHistoryService } from '../../../services/interaction-history.service';


export interface Element {
  domain: string;
  topic: string;
  subTopic: string;
}
@Component({
  selector: 'app-wrap-up',
  templateUrl: './wrap-up.component.html',
  styleUrls: ['./wrap-up.component.scss']
})

export class WrapUpComponent implements OnInit,OnChanges {

  @ViewChildren(MatSelect) select!: QueryList<MatSelect>;
  // CCR1-15200 Tracks the state of the "Make another call" checkbox
  makeAnotherCallCheckboxTicked: boolean = false;
  channelCall:string = Constants.conversion.call;

  @HostListener('window:scroll', [])
  onScroll(): void {
    this.select.forEach((matSelect) => {
      if (matSelect.panelOpen) {
        matSelect.close();
      }
    });
  }
  @Input() id: any;
  tableData: any = [];
  dataSource: MatTableDataSource<Element> = new MatTableDataSource<Element>([]);
  displayedColumns = ['domain', 'topic', 'subTopic'];
  topicList: any = [];
  subTopicList: any = [];
  duplicateTopic: any = {};
  index = null;
  ten: number = Constants.TEN;
  topicArrow = Constants.TOPIC_ARROW;
  feedbackConst = Constants.FEEDBACK;
  tpConst = Constants.TP;
  showAddTopicModal: boolean = false;
  interactionTypes : any[] = [];
  interactionModes : any[] = [];
  interactionModeSubTypes : any[] = [];
// CCR1-12455 wrap-up fields for call disposition
  whereSingleSelect: string = ''; // Transfer Case
  whereMultiSelect: string[] = []; // Referral Case
  otherCharLength: number = 0;
  howInteractionEndedOptions:any[]=[];
  whereOptions : any[]=[];
  otherTxt = Constants.WRAP_UP_DISPOSITION_CONSTANTS.OTHER;
  wrapUpData: WrapUpData = new WrapUpData;

  private readonly DEFAULT_SIM_TOPIC = Constants.DEFAULT_SIM_TOPIC;

  constructor(public rootScope: RootScopeService,
    private apiService: ApiService, public genesysCloudService: GenesysCloudService,
    public customerService: CustBusService,
    public initHistService: InteractionHistoryService) {

  }

  ngOnInit(): void {
  this.interactionTypes = this.rootScope.interactionTypeList;
  this.interactionModes = this.rootScope.interactionModesList;
  this.interactionModeSubTypes = this.rootScope.interactionModeSubTypeList;
  // CCR1-12455 initialize wrap-up fields for call disposition
  this.howInteractionEndedOptions = this.rootScope.interactionDispositionMethodList;
  this.whereOptions = this.rootScope.interactionDispositionLocationList;
  }


  ngOnChanges(changes) {
    if (changes.id.currentValue != changes.id.previousValue) {
      this.checkData();
    }
  }

  onInteractionModeChange(event) {
    if (this.rootScope.activeCustTab.wrapUpData.interactionMode != 'Outbound') {
      this.rootScope.activeCustTab.wrapUpData.interactionModeSubType = '';
    }
    this.updateWrapUpInElasticCache();
  }


  checkInboundCall() {
    if (this.rootScope.activeCustTab.activeCall && this.rootScope.callType == Constants.INBOUND_CALL_TYPE) {
      return true;
    } else {
      return false;
    }
  }











  addTopicModal() {
    this.showAddTopicModal = true;
    this.clearTopic();

  }



  closeAlertPopup() {
    this.showAddTopicModal = false;
  }


  getCustomerType() {
    let obj = _.find(this.rootScope.customerTypeData, (each) => each.fieldValue == this.rootScope.activeCustTab?.customerType)
    if (obj) {
      return obj?.fieldValueDescription
    }
    else return '';

  }

  /**CCR1-4329
    * @author Amarjeet
    *updateWrapupStatus()-Method to show cross call/chat icon after call/chat wrappedUp from care portal
    */
  updateWrapupStatus() {
    this.rootScope.activeCustTab.wrappedupCroosIcon = this.enableCloseButton();
    return this.rootScope.activeCustTab.wrappedupCroosIcon;
  }

  enableCloseButton() {

    if  (this.rootScope.activeCustTab.activeChat || this.rootScope.activeCustTab.activeCall) {
      return false;
    }
   else return this.wrapUpValidation();

  }
/**
 * 
 * @returns true/false to enable/disable close button
 * validate all input fileds in wrap up page
 */
  wrapUpValidation(){

    if (this.rootScope.activeCustTab?.wrapUpData.interactionTypeVal
      && this.rootScope.activeCustTab?.wrapUpData.interactionMode 
      && this.rootScope.activeCustTab?.wrapUpData.comments
      && this.rootScope.activeCustTab?.wrapUpData.wrapupTopicList.length > 0) {

        
      // CCR1-12455 NEW CALL DISPOSITION VALIDATION 
      if (this.isTransfer() || this.isReferral()) {
        // 'Where' field is required if How Interaction Ended=Transfer or Referral
        if (!this.rootScope.activeCustTab?.wrapUpData.whereSingleSelect &&
          (!this.rootScope.activeCustTab?.wrapUpData.whereMultiSelect || this.rootScope.activeCustTab?.wrapUpData.whereMultiSelect.length === 0)) {
          return false;
        }
        // 'Other' field required and limited to 30 chars if 'Other' selected
        if ((this.rootScope.activeCustTab?.wrapUpData.whereSingleSelect === Constants.WRAP_UP_DISPOSITION_CONSTANTS.OTHER ||
          this.rootScope.activeCustTab?.wrapUpData.whereMultiSelect?.includes(Constants.WRAP_UP_DISPOSITION_CONSTANTS.OTHER)) &&
          (!this.rootScope.activeCustTab?.wrapUpData.whereOtherText ||
            this.rootScope.activeCustTab?.wrapUpData.whereOtherText.length > 30)) {
          return false;
        }
      }

      if (this.rootScope.activeCustTab?.wrapUpData.interactionMode == 'Outbound' && this.rootScope.activeCustTab?.customerType == Constants.TP) {
        if (this.rootScope.activeCustTab?.wrapUpData.interactionModeSubType && this.rootScope.activeCustTab?.wrapUpData.thirdParty)

          return true;
        else
          return false;
      }
      else if (this.rootScope.activeCustTab?.customerType == Constants.TP) {
        if (this.rootScope.activeCustTab?.wrapUpData.thirdParty)
          return true;
        else
          return false;
      }
      else if (this.rootScope.activeCustTab?.wrapUpData.interactionMode == 'Outbound')
        if (this.rootScope.activeCustTab?.wrapUpData.interactionModeSubType)
          return true;
        else
          return false;
      else
        return true;

    }
    else return false;
  
  }
/**
 * @author VamsiKrishna
 * @returns true/false
 * based on wrap up input fileds validation 
 * live call interaction status
 */
  enableSyncLink(){
    if(this.rootScope.activeCustTab.activeCall||this.rootScope.activeCustTab.activeChat){
      return this.wrapUpValidation();
    }
    else return false;
  }



  /** 
* topicForm -- holding domain, topic & subTopic field value with validation .
* @author :Amarjeet Kumar
*/
  topicForm = new FormGroup({
    domain: new FormControl('', Validators.required),
    topic: new FormControl('', Validators.required),
    subTopic: new FormControl('', Validators.required),
  });

  domainList: any = [];
  showLoader: boolean = false;
  isDomainListAPIError: boolean = false;
  /** 
 * checkData -- checking for cached data.
 * @author :Amarjeet Kumar
 */
  checkData() {
    if (this.rootScope.wrapupTopicDataMap[this.rootScope.activeCustTab.clientId])
      this.domainList = this.rootScope.wrapupTopicDataMap[this.rootScope.activeCustTab.clientId];
      this.domainList?.sort((a, b) => a?.topicName?.localeCompare(b?.topicName)); 
    // else
    //this.getDomainList()
    if (this.rootScope.activeCustTab.wrapUpData?.wrapupTopicList?.length > 0) {
      this.rootScope.wrapupTopicList = this.rootScope.activeCustTab.wrapUpData.wrapupTopicList;
      if (!this.rootScope.activeCustTab?.wrapUpData?.primaryTopic)
        this.defaultPrimary();
    }
    else {
      this.rootScope.wrapupTopicList = [];
    }

     // CCR3-5305: only inject default topic when simulation mode is active (authoritative flag)
    if (this.rootScope?.simulationData?.isSimulationModeActive) {
      this.ensureDefaultSimulationTopic();
    }
    this.topicIndex = {
      id: null,
      name: null
    };
  }

  /** 
  * getTopicList -- creating topicList list After domain selection.
  * @author :Amarjeet Kumar
  */
  getTopicList(data: any, event: any) {
    if (event?.isUserInput) {
      this.topicList = data?.subTopicsist;
      this.topicList?.sort((a, b) => a?.topicName?.localeCompare(b?.topicName)); 
      this.topicForm.reset();
      this.subTopicList = [];
    }
  }


  /** 
  * getSubTopicList -- creating subTopicList list After topic selection.
  * @author :Amarjeet Kumar
  */
  getSubTopicList(data: any, event: any) {
    if (event?.isUserInput) {
      this.subTopicList = data?.subTopicsist;
      this.subTopicList?.sort((a, b) => a?.topicName?.localeCompare(b?.topicName)); 
      this.topicForm
        .get('subTopic')
        ?.setValue(null);
    }
  }


  /** 
   * addTopic -- adding topic list After clicking on add topic button.
   * @author :Amarjeet Kumar
   */
  addTopic() {
    this.duplicateTopic = this.tableData.find(x => x.domain == this.topicForm.get('domain')?.value && x.topic == this.topicForm.get('topic')?.value && x.subTopic == this.topicForm.get('subTopic')?.value)
    if (this.duplicateTopic == undefined) {
      this.tableData.push({
        domain: this.topicForm.get('domain')?.value,
        topic: this.topicForm.get('topic')?.value,
        subTopic: this.topicForm.get('subTopic')?.value,
      });
      this.dataSource = new MatTableDataSource<Element>(this.tableData);
      this.duplicateTopic = {};
      this.topicList = [];
      this.subTopicList = [];
      this.topicForm.reset();
    }
  }

  /** 
   * selectedRow --  After clicking on topic list highlighting selected row .
   * @author :Amarjeet Kumar
   */
  selectedRow(index) {
    this.index = index;
  }

  /** 
  * deleteTopic -- After topic selection on delete icon click action deleting the selected topic.
  * @author :Amarjeet Kumar
  */
  deleteTopic(index) {
    if (index != null) {
      this.dataSource.data.splice(index, 1);
      this.dataSource = new MatTableDataSource(this.tableData);
      this.index = null
    }
  }

  /** .
 * clearTopic -- clearing all dropdowns & topic list After clicking on Clear all button.
 * @author :Amarjeet Kumar
 */
  clearTopic() {
    this.topicForm.reset();
    this.dataSource = new MatTableDataSource();
    this.topicList = [];
    this.subTopicList = [];
    this.tableData = [];
    this.duplicateTopic = {};
  }

  /** 
 * submitTopic -- Submitting  topic list into wrapup form topic list After clicking on Submit button.
 * @author :Amarjeet Kumar
 */
  submitTopic() {
    this.showAddTopicModal = false;
    if (this.rootScope.wrapupTopicList.length > 0) {
      this.rootScope.wrapupTopicList = this.rootScope.wrapupTopicList.filter(x => {
        delete x.id;
        return true;
      });
    }

    this.rootScope.wrapupTopicList = [...this.rootScope.wrapupTopicList, ...this.tableData];
    let unique: any = Array.from(new Set(this.rootScope.wrapupTopicList.map(JSON.stringify)))
    this.rootScope.wrapupTopicList = unique.map(JSON.parse);
    if (this.rootScope.wrapupTopicList) {
      for (let i = 0; i < this.rootScope.wrapupTopicList.length; i++) {
        this.rootScope.wrapupTopicList[i].id = i;
      }
    }
    this.rootScope.activeCustTab.wrapUpData.wrapupTopicList = this.rootScope.wrapupTopicList;
    if (!this.rootScope.activeCustTab?.wrapUpData?.primaryTopic) {
      this.defaultPrimary();
    }
    this.updateWrapUpInElasticCache();
  }

  /** 
 * wrapupSelectedRow -- Highlighting row on topic selection.
 * @author :Amarjeet Kumar
 */
  topicIndex = {
    id: null,
    name: null
  };
  wrapupSelectedRow(row) {
    this.topicIndex = row;
  }

  /** 
 * makePrimary -- Making selected topic primary After clicking on "*" icon button.
 * @author :Amarjeet Kumar
 */
  makePrimary(topic) {
    if (topic.id != null) {
      this.rootScope.activeCustTab.wrapUpData.primaryTopic = topic?.domain + Constants.TOPIC_ARROW + topic.topic + Constants.TOPIC_ARROW +
        topic?.subTopic;
      // this.rootScope.activeCustTab.wrapUpData.domain = topic?.domain;
    }
    this.updateWrapUpInElasticCache();
  }


  /** 
 * deleteWrapupTopic -- Deleteting selected topic from Topic list After clicking on Delete icon.
 * @author :Amarjeet Kumar
 */
  deleteWrapupTopic(topic) {


    if (this.isDefaultTopic(topic)) {
    return; // CCR3-5305 Cannot delete default simulation topic
  }

    if (topic.id != null) {
      this.rootScope.wrapupTopicList = this.rootScope.wrapupTopicList.filter(x => x.id != topic.id);
      this.topicIndex = {
        id: null,
        name: null
      };
      if (this.rootScope.activeCustTab.wrapUpData.primaryTopic == topic?.domain + Constants.TOPIC_ARROW + topic?.topic + Constants.TOPIC_ARROW + topic?.subTopic) {
        this.defaultPrimary();
        if (this.rootScope.wrapupTopicList.length == 0)
          this.rootScope.activeCustTab.wrapUpData.primaryTopic = null;
      }
      this.rootScope.activeCustTab.wrapUpData.wrapupTopicList = this.rootScope.wrapupTopicList;
    }
    this.updateWrapUpInElasticCache();
  }

  /**
   * Below method gets called when Close ACcount button is triggered.
   * It updates the IH model that is already created for current tab with 
   * detail /description and wrapUpdata  and triggres closing of the tab on 
   * click of this button. (for chat and call both) CCR1-3999.
   * Listener of variable "wrappedUpComplete" is in header.component.ts
   * @author :Pooja
   */

  closeAccountButtonClicked(accountToBeClosed:boolean) {
    if (!this.rootScope.activeCustTab.wrappedupCroosIcon) {
      return;
    }

    
    // CCR1-12455 Convert the "Other" field to uppercase before saving
    const wrapUp = this.rootScope.activeCustTab?.wrapUpData;
    if (wrapUp?.whereOtherText) {
      wrapUp.whereOtherText = wrapUp?.whereOtherText.toUpperCase();
    }

    this.rootScope.wrappedUpComplete.next({ accountToBeClosed: accountToBeClosed });
  }


  /** 
 * defaultPrimary -- making first topic primary by default from Topic list.
 * @author :Amarjeet Kumar
 */
  defaultPrimary() {
    this.rootScope.activeCustTab.wrapUpData.primaryTopic = this.rootScope.wrapupTopicList[0]?.domain + Constants.TOPIC_ARROW + this.rootScope.wrapupTopicList[0]?.topic + Constants.TOPIC_ARROW +
      this.rootScope.wrapupTopicList[0]?.subTopic;
    // this.rootScope.activeCustTab.wrapUpData.domain = this.rootScope.wrapupTopicList[0]?.domain;
  }

  /** 
* feedback -- saving feedback from UI screen 'Dissatisfied' or 'Kudos'.
* @author :Amarjeet Kumar
*/
  feedback(feedback) {
    if (this.rootScope.activeCustTab.wrapUpData.interactionFeedback == feedback) {
      this.rootScope.activeCustTab.wrapUpData.interactionFeedback = '';
    } else {
      this.rootScope.activeCustTab.wrapUpData.interactionFeedback = feedback;
    }
    this.updateWrapUpInElasticCache();
  }

  /**
 * Updates the wrap-up data and invokes the method to update it in Elastic Cache.
 * @param event The event triggering the wrap-up update.
 */
  updateWrapUp(event: any) {
    this.updateWrapUpInElasticCache();
  }

   /**
   * @author VamsiKrishna
   * the livecall/chat status in active tab
   * 
   */
 /* istanbul ignore next */
  onClickLiveStatus() {
    if(this.rootScope.simulationData?.isSimulationToggleOn || !this.rootScope.isGenesysLoggedIn) {
      return;
    }
    this.rootScope.increAlisRefreshCounter('REFRESH_WRAPUP_COUNT');// Called for increment refresh count on user refresh action-CCR3-6969
    this.rootScope.activeCustTab.wrapUpData.callStatus = "";
    this.genesysCloudService.syncLivestatus(this.rootScope.activeCustTab.channel);
  }

   /**
   * @author HASHID N K
   * Handle keyborad key events in wrapup topic selection section
   * Once the 'Enter' key or space ' ' key is pressed,triggers row selectin logic via 'wrapupSelectedRow'
   * @param event-keyboard event triggered by the user input
   * @param data - data assocaited with selected row
   */
  onKeyDown(event: KeyboardEvent, data: any): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.wrapupSelectedRow(data);
    }
  }

  /**
  * Updates the wrap-up data in Elastic Cache.
  */
  updateWrapUpInElasticCache() {
    let updtCustPayload = {
      customerSessionId: this.rootScope.activeCustTab.customerSessionId,
      cusTab: { wrapUpData: this.rootScope.activeCustTab.wrapUpData },
    };
    this.customerService.updateCustomerInElasticCache(updtCustPayload);
  }

  onTextareaChanged(event: any) {
    if(event.detail?.value?.length) {  
      this.rootScope.activeCustTab.wrapUpData.comments = event?.detail?.value;
    }
  }

  /**
   * Checks if there is an error message related to the call summary in the wrap-up data.
   *
   * Returns `true` if any of the following conditions are met:
   * - The call summary API is forbidden (`isCallSummaryApiForbidden`)
   * - The user does not have permission for the call summary API (`isCallSummaryApiNoPermission`)
   * - The call summary is too short (`isCallSummaryTooShort`)
   *
   * @returns {boolean} `true` if any call summary error condition exists, otherwise `false`.
   */
  checkSummaryErrorMessage() {
    const aiSummaryStatus = this.rootScope.activeCustTab?.aiSummaryStatus || {};
    return !!(
      aiSummaryStatus?.isCallSummaryApiForbidden ||
      aiSummaryStatus?.isCallSummaryApiNoPermission ||
      aiSummaryStatus?.isCallSummaryTooShort
    );
  }

  
  /**
   * Determines whether the "Get Summary" button should be enabled or disabled.
   *
   * The button is enabled if there is an active call, an active chat, or if the call summary is currently being fetched.
   * Returns `true` if any of these conditions are met, otherwise returns `false`.
   *
   * @returns {boolean} `true` if the button should be enabled; `false` otherwise.
   */
  checkGetSummaryButtonEnabledOrDisabled(): boolean {

    // CCR3-5305 Disable the button if simulation mode is active.
    if (this.rootScope?.simulationData?.isSimulationModeActive||this.rootScope.activeCustTab.isMultipleAccountTabOpened) {
    return true; 
    }

    const aiSummaryStatus = this.rootScope.activeCustTab?.aiSummaryStatus || {};
    return !!(
      this.rootScope.activeCustTab?.activeCall ||
      this.rootScope.activeCustTab?.activeChat ||
      this.rootScope.activeCustTab.aiSummaryStatus.isCallSummaryAvailable ||
      aiSummaryStatus?.isCallSummaryFetching 
    );
  }

   /**
   * Resets all call summary error flags in the wrap-up data.
   * Clears permission, length, forbidden, and generic error states.
   */
  closeAlertMessage(){
    this.rootScope.activeCustTab.aiSummaryStatus.isCallSummaryApiNoPermission = false;
    this.rootScope.activeCustTab.aiSummaryStatus.isCallSummaryTooShort = false;
    this.rootScope.activeCustTab.aiSummaryStatus.isCallSummaryApiForbidden = false;
    this.rootScope.activeCustTab.aiSummaryStatus.isCallSummaryApiError = false;
  }


  /**
   * Handles the click event for fetching conversation summaries.
   * Closes any active alert messages and requests summaries from Genesys Cloud
   * using the current active customer's conversation ID.
   */
  onClickSummaries(){
    this.closeAlertMessage();
    this.rootScope.activeCustTab.aiSummaryStatus.isCallSummaryFetching = true;
    this.genesysCloudService.getSummaries(this.rootScope.activeCustTab?.conversationId);
  }
 

  /**
 * CCR3-5305 Checks if a topic is the default simulation topic and should not be deletable
 * @param topic - The topic to check
 * @returns boolean - true if topic is default and cannot be deleted
 */
isDefaultTopic(topic: any): boolean {
  return !!(topic?.isDefault);
}


// CCR3-5305 Ensures that the default simulation topic is present in the wrap-up topic list
ensureDefaultSimulationTopic(): void {
   // Step 1: Make sure wrapupTopicList is an array
    if (!Array.isArray(this.rootScope.wrapupTopicList)) {
      this.rootScope.wrapupTopicList = [];
    }

    // Step 2: Check if default topic already exists
    const exists = this.rootScope.wrapupTopicList.some((t: any) =>
      t?.isDefault || // Look for topic marked as default
      (t?.domain === this.DEFAULT_SIM_TOPIC.domain &&
        t?.topic === this.DEFAULT_SIM_TOPIC.topic &&
        t?.subTopic === this.DEFAULT_SIM_TOPIC.subTopic)
    );

    // Step 3: If it doesn't exist, add it
    if (!exists) {
      // put default first so it is visible and preserved
      this.rootScope.wrapupTopicList = [{ ...this.DEFAULT_SIM_TOPIC }, ...this.rootScope.wrapupTopicList];

      // assign ids (keep default id stable)
      for (let i = 0; i < this.rootScope.wrapupTopicList.length; i++) {
        if (!this.rootScope.wrapupTopicList[i].isDefault) {
          this.rootScope.wrapupTopicList[i].id = i;
        }
      }

      // persist back to active tab
      this.rootScope.activeCustTab.wrapUpData = this.rootScope.activeCustTab.wrapUpData || {};
      this.rootScope.activeCustTab.wrapUpData.wrapupTopicList = this.rootScope.wrapupTopicList;

      // ensure primary exists
      if (!this.rootScope.activeCustTab?.wrapUpData?.primaryTopic) {
        this.defaultPrimary();
      }
      this.updateWrapUpInElasticCache();
    }
  }

  
// CCR1-12455 Wrap Up Disposition related methods  
isTransfer(){
  return this.rootScope.activeCustTab?.wrapUpData.howInteractionEnded === Constants.WRAP_UP_DISPOSITION_CONSTANTS.TRANSFER;
}

isReferral(){
  return this.rootScope.activeCustTab?.wrapUpData.howInteractionEnded === Constants.WRAP_UP_DISPOSITION_CONSTANTS.REFERRAL;
}

onHowInteractionEndedChange(event?: any):void {
  const data = this.rootScope.activeCustTab?.wrapUpData;

  // reset fields when switched
  data.whereSingleSelect = '';
  data.whereMultiSelect = [];
  // reset "Other" field and character count when disposition method changes, to prevent orphaned data if user had selected "Other" previously
  data.whereOtherText = '';
  this.otherCharLength = 0;
 
  // Persist all changes to Elastic Cache
  this.updateWrapUpInElasticCache();
}


/**
 * CCR1-12455 Handles "Where" field selection change for Transfer/Referral disposition
 * Clears "Other" text field if "Other" option is not selected
 */
onWhereSelectionChange(event?: any): void {
  const wrapUpData = this.rootScope.activeCustTab?.wrapUpData;
  
  // Determine which "Where" values are currently selected based on disposition type
  let selectedLocations: string[] = [];
  
  // For Transfer: single select - convert to array for consistent checking
  if (this.isTransfer() && wrapUpData.whereSingleSelect) {
    selectedLocations = [wrapUpData.whereSingleSelect];
  }
  
  // For Referral: multi-select - already an array
  if (this.isReferral() && wrapUpData.whereMultiSelect?.length > 0) {
    selectedLocations = wrapUpData.whereMultiSelect;
  }
  
  // Auto-clear "Other" text when "Other" option is NOT selected
  // This prevents orphaned data when user deselects "Other"
  if (!selectedLocations.includes(Constants.WRAP_UP_DISPOSITION_CONSTANTS.OTHER)) {
    wrapUpData.whereOtherText = '';
    this.otherCharLength = 0; // Reset character counter
  }
  
 
  // Persist changes to Elastic Cache for Transfer cases immediately on selection change
  if (this.isTransfer() && wrapUpData?.whereSingleSelect) {
    this.updateWrapUpInElasticCache();
  }
}

onOtherInputChanged(event: any): void {
    const raw: string = (event?.detail?.value ?? event?.target?.value ?? '');
    // Remove all line breaks (defensive handling for pasted content)
    let normalized = raw?.replace(/[\r\n]/g, '');
    if (normalized?.length > 30) {
      normalized = normalized?.substring(0, 30);
    }
    // Update the wrap-up data with the normalized "Other" text
    this.rootScope.activeCustTab.wrapUpData.whereOtherText = normalized;
    // Update character count for "Other" field, which has a max of 30 chars
    this.otherCharLength = normalized?.length;
  }

  onWhereMultiSelectClosed(): void {
  const wrapUpData = this.rootScope.activeCustTab?.wrapUpData;
  if (!wrapUpData || !this.isReferral()) {
    return;
  }

  const hasValues = Array.isArray(wrapUpData?.whereMultiSelect) && wrapUpData?.whereMultiSelect?.length > 0;
  if (hasValues) {
    this.updateWrapUpInElasticCache();
  }
}

/**CCR1-15200 Handles the change event for the "Make another call" checkbox */
onCheckboxChange(event: { checked: boolean }) {
  console.log(event.checked);
  this.rootScope.activeCustTab.makeAnotherCallCheckboxTicked = event.checked;
}

submitButtonButtonClicked(){

}

}



